import { instance } from '../../requests/axios.instance';

/**
 * Banque de liens de l'entreprise.
 *
 * Contrat arrêté avec le back (`docs/webviewer/prompt-back-banques.md` §2.4) :
 * la lecture se fait du point de vue du document édité, qui borne le niveau
 * « métier », et `current_user` borne le reste — un utilisateur standard ne
 * reçoit jamais les liens personnels d'un collègue.
 *
 *   GET /proposal/:id/web_links
 *   GET /proposals/web_templates/:id/web_links
 *   → [{ kind: 'folder'|'user', id, name, scope, web_links: [...] }]
 *
 * Le back sert des **groupes** déjà triés, pas une liste plate : un dossier par
 * lien d'entreprise ou de métier, la personne elle-même pour les liens
 * personnels — qui n'ont donc jamais de dossier (`web_link_folder_id: null`,
 * c'est normal). `scope` est servi calculé, sur le groupe comme sur le lien :
 * le front n'a pas à le réinférer depuis deux colonnes nullables.
 *
 * ⚠️ L'identité utilisée n'est pas la même que pour la banque d'images. Les
 * images sont servies par le **document d'origine** (opportunité ou offre,
 * `projectConfig.documentIdentity`) ; les liens le sont par le **proposal**
 * lui-même, dont le back tire le métier via sa colonne `work`.
 */

function webLinksUrl({ type, id }) {
  return type === 'proposal'
    ? `/proposal/${id}/web_links`
    : `/proposals/web_templates/${id}/web_links`;
}

/**
 * Les liens visibles pour ce document.
 *
 * Contrairement à `getImageBank`, les erreurs ne sont **pas** avalées : le
 * registre doit pouvoir distinguer « la banque est vide » de « la banque n'a
 * pas pu être lue », les deux ne se disent pas pareil à l'utilisateur.
 */
export async function fetchWebLinks(context) {
  const { type, id } = context || {};
  if (!id || (type !== 'proposal' && type !== 'web_template')) {
    throw new Error('contexte de banque de liens invalide');
  }

  const res = await instance.get(webLinksUrl({ type, id }));
  if (res.status !== 200) throw new Error(`GET web links status code ${res.status}`);
  return Array.isArray(res.data) ? res.data : [];
}
